import React from 'react';
import { Phone } from 'lucide-react';
import { motion } from 'framer-motion';

const FloatingButtons: React.FC = () => {
  const phoneNumber = process.env.REACT_APP_PHONE_NUMBER || '+91889690900';
  const whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER || '919119901924';

  return (
    <div className="fixed bottom-6 left-6 z-40 flex flex-col space-y-3">
      {/* WhatsApp Button */}
      <motion.a
        href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in your architectural services.`}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center justify-center w-10 h-10 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-md hover:shadow-lg transition-all duration-300 relative"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.5 }}
      >
        {/* Proper WhatsApp SVG */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          fill="currentColor"
          className="w-4 h-4"
        >
          <path d="M16.001 0C7.163 0 0 7.163 0 16c0 2.822.737 5.459 2.014 7.774L0 32l8.477-2.023A15.928 15.928 0 0016 32c8.837 0 16-7.163 16-16S24.838 0 16.001 0zm7.793 22.666c-.305.854-1.798 1.606-2.52 1.708-.662.095-1.445.134-5.91-1.949-4.446-2.086-7.26-6.634-7.476-6.873-.216-.24-1.772-2.602-1.772-4.951 0-2.352 1.21-3.518 1.64-3.995.431-.476.96-.598 1.28-.598.32 0 .645 0 .927.002.28.003.65-.108.99.78.34.888 1.16 3.07 1.26 3.296.1.226.166.492.033.79-.13.298-.196.49-.396.764-.2.274-.425.605-.608.815-.2.226-.412.48-.293.78.118.3.524.844.884 1.374.61.866 1.12 1.14 2.063 1.847.946.708 1.686.59 1.924.52.237-.07 1.54-.636 1.754-1.255.214-.62.214-1.152.15-1.255-.066-.104-.24-.165-.5-.287-.256-.122-1.516-.705-1.752-.786-.237-.082-.41-.123-.566-.123-.157 0-.338.003-.485.003-.146 0-.343.022-.52.343-.175.32-.63.742-.63.742s-.18.33-.257.498c-.075.167-.15.366-.075.597.075.23.627 1.156 1.36 1.768.73.61 1.47.823 1.746.916.276.092.552.08.76.048.206-.033.63-.257.724-.507.093-.252.4-1.01.503-1.345.102-.336.2-.333.336-.33.135.003.43.012.654.127.224.116.72.344.823.646.1.303.1.564.07.616z" />
        </svg>

        <span className="absolute left-14 bg-gray-900 text-white text-xs px-2 py-1 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
          Chat on WhatsApp
        </span>
      </motion.a>

      {/* Call Button */}
      <motion.a
        href={`tel:${phoneNumber}`}
        className="group flex items-center justify-center w-10 h-10 bg-blue-500 hover:bg-blue-600 text-white rounded-full shadow-md hover:shadow-lg transition-all duration-300 relative"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.7 }}
      >
        <Phone className="w-4 h-4" />
        <span className="absolute left-14 bg-gray-900 text-white text-xs px-2 py-1 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
          Call Now
        </span>
      </motion.a>
    </div>
  );
};

export default FloatingButtons;
